<template>
    <div>
        <a v-if="!visible" href @click.prevent="show(tutorial.id)" class="tool-tip-put-back">SHOW TUTORIAL <span class="fa fa-lightbulb"></span></a>

        <div v-show="visible" class="list-page remove-buffer">
            <div class="tool-tip">
                <div class="left">
                    <div class="headline">{{ tutorial.title }}</div>
                    <div v-html="tutorial.text"></div>
                    <a href @click.prevent="hide(tutorial.id)" class="guide-button">HIDE THIS TUTORIAL <span class="fab fa-buromobelexperte"></span></a>
                    <a href @click.prevent="hideAll" class="guide-button lighter-bg">HIDE ALL TUTORIALS <span class="fa fa-layer-group"></span></a>
                </div>
                <div class="right"><span class="fa fa-lightbulb"></span><div class="small-text">TUTORIAL</div></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    props: [ 'tutorial', 'userHidTutorial' ],

    data() {
        return {
            visible: this.userHidTutorial !== true,
        };
    },

    methods: {

        hide(id) {
            axios.get(`/tutorial/${ id }/hide`);
            this.visible = false;
        },

        hideAll() {
            axios.get('/tutorial/all/hide');
            this.visible = false;
        },

        show(id) {
            axios.get(`/tutorial/${ id }/show`);
            this.visible = true;
        }
    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/layouts/Tutorials.vue